var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 15.3446C28 14.3249 27.9212 13.2998 27.7533 12.2966H14.2808V18.0729H21.9959C21.6757 19.9358 20.647 21.5838 19.1407 22.631V26.3789H23.7436C26.4465 23.7664 28 19.9082 28 15.3446Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2806 29.9999C18.1329 29.9999 21.3816 28.6716 23.7487 26.3788L19.1458 22.6308C17.8652 23.5458 16.212 24.0639 14.2859 24.0639C10.5595 24.0639 7.40001 21.4238 6.26637 17.8743H1.5166V21.7379C3.94134 26.8032 8.88005 29.9999 14.2806 29.9999Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26148 17.8744C5.66316 16.0115 5.66316 13.9942 6.26148 12.1313V8.26758H1.51696C-0.508908 12.506 -0.508908 17.4996 1.51696 21.7381L6.26148 17.8744Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2806 5.9361C16.317 5.90303 18.2851 6.70773 19.7599 8.18486L23.8379 3.90229C21.2557 1.3559 17.8285 -0.0440591 14.2806 3.427e-05C8.88005 3.427e-05 3.94134 3.1968 1.5166 8.26753L6.26112 12.1312C7.38952 8.57619 10.5543 5.9361 14.2806 5.9361Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.488c0a3e6f64339108158dc06929b61c.svg";
export { ForwardRef as ReactComponent };